import { Button, HStack, Icon, Input } from '@genial/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { Pressable } from 'native-base';
import { Control, useForm } from 'react-hook-form';
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native';
import z from 'zod';

interface SearchTermProps {
  loading: boolean;
  onSearch: (term: string) => void;
  isMobile: boolean;
}

const SearchSchema = z.object({
  searchTerm: z.string().min(3, 'Mínimo de 3 caracteres'),
});

type SearchSchemaInput = z.infer<typeof SearchSchema>;

export const SearchTerm = ({ loading, isMobile, onSearch }: SearchTermProps) => {
  const formSearch = useForm<SearchSchemaInput>({
    resolver: zodResolver(SearchSchema),
    defaultValues: { searchTerm: '' },
    mode: 'all',
  });

  const isValidSearch = formSearch.formState.isValid;

  const handleInputBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    if (!e.nativeEvent.text) {
      handleClearSearchTerm();
    }
  };

  const handleUpdateSearchTerm = (data: SearchSchemaInput) => {
    onSearch(data.searchTerm);
  };

  const handleClearSearchTerm = () => {
    formSearch.setValue('searchTerm', '');
    onSearch('');
  };

  return (
    <HStack width="full" space="inline.xxxs">
      <Input
        testId="product-search-input"
        placeholder="Pesquise por protocolo"
        noValidate={true}
        name="searchTerm"
        onSubmitEditing={formSearch.handleSubmit(handleUpdateSearchTerm)}
        control={formSearch.control as unknown as Control}
        onBlur={handleInputBlur}
        isDisabled={loading}
        error={formSearch.formState.errors.searchTerm}
        autoComplete="off"
        variant="rounded"
        inputRightElement={
          <Pressable
            onPress={() => {
              isValidSearch ? handleClearSearchTerm() : null;
            }}
            pr={isValidSearch ? 3 : 4}
            isDisabled={loading}>
            <Icon name={isValidSearch ? 'Close' : 'Search'} size="xxxs" />
          </Pressable>
        }
      />
      {!isMobile && (
        <Button
          variant="primary"
          onPress={formSearch.handleSubmit(handleUpdateSearchTerm)}
          isDisabled={!isValidSearch || loading}>
          Buscar
        </Button>
      )}
    </HStack>
  );
};
